<div class="grid form-inline label-W170">
    @for (field of fields(); track field.controlName) {
        @if (showField(field.controlName)) {
            <div class="col-12 mb-1">
                <label [for]="field.controlName" class="label-min-width">{{ field.labelKey | translate }}</label>
                <div class="read-only">
                    <span [id]="field.controlName">
                        @if (field.type === 'text') {
                            {{ form().get(field.controlName).value }}
                        } @else if (field.type === 'date') {
                            {{ form().get(field.controlName).value | date: 'dd/MM/yyyy' }}
                        }
                    </span>
                </div>
            </div>
        }
    }
</div>
